import { BackgroundExportTypes } from 'further-types/background-exports';

export const BackgroundExportTypeLabels: Record<BackgroundExportTypes, string> =
  {
    CASH_TRANSACTIONS_REPORT: 'Cash transactions report',
    INVESTOR_SITE_CASH_TRANSACTIONS_REPORT: 'Cash transactions report',
    INVESTMENT_HOLDINGS_REPORT: 'Investment holdings report',
    INVESTMENT_TRANSACTIONS_REPORT: 'Subscription transactions report',
    INVESTOR_SITE_INVESTMENT_TRANSACTIONS_REPORT:
      'Subscription transactions report',
    INVESTMENTS_EXPORT: 'Subscriptions export',
    ADVISER_STATEMENT_EXPORT: 'Adviser statement export',
    ADVISER_STATEMENT_EXPORT_ALL_FIRMS: 'Adviser statement export',
    ORGANISATION_STATEMENT_EXPORT: 'Organisation statement export',
    INVESTOR_EXPORT: 'Investor export',
    FEES_EXPORT: 'Fees export',
    EIS_TASKLIST_EXPORT: 'S/EIS tasklist export',
    COMPANIES_EXPORT: 'Companies export',
    EXITS_EXPORT: 'Exits export',
    ADVISERS_EXPORT: 'Advisers export',
    ORGANISATIONS_EXPORT: 'Organisations export',
    BILLING_EXPORT: 'Billing export',
    PORTAL_USAGE_DATA_REPORT: 'Portal usage data report',
  };
